import { motion } from "framer-motion";
import { MEDIA, STATS } from "../../data/content";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-nav py-24 md:py-36 border-t border-ink/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          className="grid grid-cols-12 gap-6 md:gap-10"
        >
          {/* Left: section label */}
          <div className="col-span-12 md:col-span-3">
            <div className="md:sticky md:top-28">
              <div className="overline text-forest-accent mb-3">/ 01 — About</div>
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-soft">
                Est. 1995 · Vadodara
              </div>
            </div>
          </div>

          {/* Middle: narrative */}
          <div className="col-span-12 md:col-span-6">
            <h2 className="font-display font-bold leading-[1.05] tracking-tight text-ink text-balance"
                style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}>
              Two and a half decades of{" "}
              <span className="text-amber-accent italic font-light">
                quietly exacting
              </span>{" "}
              chemistry.
            </h2>
            <div className="mt-10 space-y-10 text-ink-soft text-base md:text-lg leading-relaxed">
              <div>
                <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-amber-accent mb-3">
                  Ch. 01 — Who we are
                </div>
                <p>
                  Milestone Preservatives Private Limited is a specialty
                  chemicals manufacturer organised around three distinct product
                  lines —{" "}
                  <span className="text-ink font-medium">Shelfanox™</span>{" "}
                  synthetic antioxidants (TBHQ, BHA, BHT, AP) for shelf life,{" "}
                  <span className="text-ink font-medium">NatPro™</span> naturally
                  derived Mixed Tocopherols for clean-label nutrition, and a{" "}
                  <span className="text-ink font-medium">Specialty Chemicals</span>{" "}
                  range (MeHQ, Guaiacol) for polymer and pharmaceutical
                  customers. Three categories, one chemistry discipline — built
                  on consistent purity, traceable feedstock and rigorous
                  process control.
                </p>
              </div>
              <div>
                <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-forest-accent mb-3">
                  Ch. 02 — How we prove it
                </div>
                <p>
                  Our laboratories pair classical wet chemistry with modern HPLC
                  and GC analytics — because a spec is only as credible as the
                  numbers behind it.
                </p>
              </div>
            </div>
          </div>

          {/* Right: image */}
          <div className="col-span-12 md:col-span-3">
            <div className="relative aspect-[3/4] overflow-hidden rounded-sm border border-ink/10">
              <img
                src={MEDIA.lab_beakers}
                alt="Clear laboratory beakers on a benchtop"
                className="w-full h-full object-cover grayscale-[0.15] saturate-[0.85]"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-ink/5" />
            </div>
          </div>
        </motion.div>

        {/* Stats strip */}
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          variants={fadeUp}
          className="mt-20 md:mt-28 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 border-t border-ink/15"
        >
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className={`py-8 md:py-10 px-4 ${
                i !== 0 ? "lg:border-l border-ink/10" : ""
              } ${i % 2 !== 0 ? "border-l border-ink/10 lg:border-l" : ""} ${
                i === 2 ? "sm:border-l border-ink/10" : ""
              }`}
            >
              <div className="font-display font-black tracking-tight text-ink text-3xl md:text-4xl xl:text-5xl whitespace-nowrap">
                {s.value}
              </div>
              <div className="mt-2 text-ink-soft text-[13px] leading-snug">
                {s.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
